<script setup lang="ts">
  import LoginSocialMedia from 'components/LoginSocialMedia.vue'    
</script>
<template>
    <div class="row my-5">
        <div class="col-lg-5 col-12 div-user">
            <legend>{{ translate.hello }}, {{ user.nickname ?? user.name }}</legend>
            <span class="subtitle">{{ translate.userSubtitle }}</span>

            <div class="row my-4">
                <div class="col-12">
                    <div class="form-group">
                        <input ref="name" type="text" class="form-control" name="nickname"
                            :placeholder="translate.placeholderNickname" v-model="form.nickname">
                    </div>
                </div>
                <div class="col-12">
                    <div class="form-group">
                        <input type="email" class="form-control" name="email" :placeholder="translate.placeholderEmail"
                            :disabled="!editar" v-model="form.email" />
                    </div>
                </div>
                <div class="col-12 d-w">
                    <label for="newsletter" class="col-4">{{ translate.labelNewsletter }}</label>
                    <input class="form-check-input" type="radio" name="newsletter" id="newsletterYes">
                    <span> {{ translate.yes }} </span>
                    <input class="form-check-input" type="radio" name="newsletter" id="newsletterNo">
                    <span>{{ translate.no }}</span>
                </div>
                <div class="col-12 mt-2 d-w">
                    <label for="promotions" class="col-4">{{ translate.labelPromotions }}</label>
                    <input class="form-check-input" type="radio" name="promotions" id="promotionsYes">
                    <span> {{ translate.yes }} </span>
                    <input class="form-check-input" type="radio" name="promotions" id="promotionsNo">
                    <span> {{ translate.no }} </span>
                </div>

                <div class="col-12 mt-3">
                    <div class="form-group">
                        <input ref="name" type="text" class="form-control password" name="password"
                            :placeholder="translate.placeholderPassword" v-model="form.password">
                    </div>
                </div>
                <div class="col-12">
                    <div class="form-group">
                        <input type="text" class="form-control password" name="repitepassword"
                            :placeholder="translate.placeholderRepitePassoword" v-model="form.repitePassword" />
                    </div>
                </div>
                <div class="text-center mt-3" v-if="loading">
                    <div class="spinner-border" role="status">
                        <span class="visually-hidden">Loading...</span>
                    </div>
                </div>
                <div v-else class="col-lg-6 col-12 mt-3">
                    <button class="button" type="submit" @click="saveUser">{{ translate.buttonLabelSave }} <i
                            class="icon-arrow-right"></i></button>
                </div>
            </div>
            <div class="d-flex">
                <LoginSocialMedia :redirect="false" size="300" @returnMessage="returnMessage"/>            
            </div>
        </div>
    </div>
</template>
  
<script lang="ts">
import { mapState, mapActions } from 'pinia'
import { defineComponent } from 'vue'
import { localeStore } from 'stores/locale'
import tradutor from 'tradutors/myaccount'
import router from "router"
import api from '../../api'
import { userStore } from '../../stores/user'
export default defineComponent({
    name: 'FromUser',
    props: ['user'],
    emits: ['showModalMessages'],
    computed: {
        ...mapState(localeStore, ['locale']),
        translate: function () {
            if (this.locale === 'pt-br') {
                return tradutor.portugues
            } else {
                return tradutor.ingles
            }
        },
        translateMessage: function () {
            if (this.locale === 'pt-br')
                return this.tradutorModal[0]
            return this.tradutorModal[1]
        }
    },
    data() {
        return {
            form: {
                nickname: this.user.nickname,
                email: this.user.email,
                password: '',
                repitePassword: '',
            },
            loading: false,
            editar: false,
            tradutorModal: [
                {
                    sucess: {
                        title: 'Sucesso',
                        textButton: 'Fechar',
                        textBoby: 'Dados atualizados!'

                    },
                    error: {
                        title: 'Error',
                        textButton: 'Fechar',
                        textBoby: 'Falha ao atualizar dados!'
                    }
                },

                {
                    sucess: {
                        title: 'Success',
                        textButton: 'Close',
                        textBoby: 'Updated user!'

                    },
                    error: {
                        title: 'Error',
                        textButton: 'Close',
                        textBoby: 'Failed to update user!'
                    }
                },
            ]
        }
    },
    mounted() {
        this.selectRadiosDefault()
        this.getUser();
    },
    methods: {
        ...mapActions(userStore, ['setUser']),
        redirect(name) {
            router.push({
                name,
                params: {
                    locale: this.locale
                }
            })
        },
        async getUser() {
            api.get('v1/myaccount/getUser').then(({ data }) => {
                this.form.nickname = data.nickname
                this.form.email = data.email
                if (!data.newsletter) {
                    document.getElementsByName('newsletter')[1].checked = true
                }

                if (!data.promotions) {
                    document.getElementsByName('promotions')[1].checked = true
                }
            })
        },
        selectRadiosDefault() {
            document.getElementsByName('newsletter')[0].checked = true
            document.getElementsByName('promotions')[0].checked = true
        },
        saveUser() {
            this.loading = true
            this.form.newsletter = false
            this.form.promotions = 0
            if (document.getElementsByName('newsletter')[0].checked == true) this.form.newsletter = true
            if (document.getElementsByName('promotions')[0].checked == true) this.form.promotions = 1

            api.post('v1/myaccount/alterUser', this.form).then(({ data }) => {
                this.setUser(data)
                this.$emit('showModalMessages', { message: { 
                    show: true, 
                    title: this.translateMessage.sucess.title, 
                    textButton: this.translateMessage.sucess.textButton, 
                    textBoby: this.translateMessage.sucess.textBoby 
                }})
            }).catch((error) => {
                this.$emit('showModalMessages', { message: { 
                    show: true, 
                    title: this.translateMessage.error.title, 
                    textButton: this.translateMessage.error.textButton, 
                    textBoby: this.translateMessage.error.textBoby 
                 }})
                console.log(error)
            }
            )
                .finally(() => this.loading = false)
        },
        returnMessage(value) {
            this.$emit('showModalMessages', { message: { 
                show: true, 
                title: 'Aviso', 
                textButton: 'Fechar', 
                textBoby: value
            }})
        }
    }
})
</script>
  
<style scoped lang="css">
.form-check-input:checked[type=radio] {
    --bs-form-check-bg-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3e%3ccircle r='2' fill='%23000'/%3e%3c/svg%3e");
}

.form-check-input:checked {
    background-color: #ffffff;
    border-color: #000;
}

label {
    font-family: 'Roboto-Bold';
    font-size: 16px;
    line-height: 19px;
}

div.col-6.div-user>div>div>span {
    font-family: 'Roboto-Regular';
    font-size: 13px;
    line-height: 15px;
    margin-right: 15px;
}

.form-check-input {
    --bs-form-check-bg: #fff;
    width: 2em;
    height: 2em;
    margin-top: 0px;
    margin-inline: 10px;
}

.form-group input {
    padding: 15px 20px;
    border-radius: 30px;
    margin-bottom: 15px;
    background-color: #fff;
    font-size: small;
    max-width: 425px;
}

div.col-6.div-user>div>div.col-12>div>input.password {
    /*max-width: 287px;*/
}

.form-control:focus {
    color: #000;
    background-color: #f8f8f8;
}

legend {
    font-family: 'Roboto-Medium';
    line-height: 28px;
    font-size: 24px;
    color: #b40909;
}

.img-alter-plan {
    width: 700px;
    height: 100%;
    object-fit: contain;
}

.subtitle {
    font-family: 'Roboto-Regular';
    font-size: 16px;
    line-height: 19px;
}

.black-title {
    color: #000;
    font-weight: bold;
    font-size: 26px;
    font-family: 'Exo-2';
    font-style: italic;
}

.subtitle span {
    font-size: 16px;
    font-weight: bold;
}


.label {
    display: flex;
    align-items: center;
    justify-content: center;
}

.d-w-btn {
    color: #fff;
    padding: 17px 100px;
    background: #000;
    border-radius: 10px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: larger;
    font-weight: 700;
    font-family: 'Exo-2';
}

.div-user {
    margin-left: 16px;
}

/* regras mobile 769vp */
@media screen and (max-width: 769px) {
    .div-user {
        width: 100%;
        margin-left: 0px;
    }

    legend {
        font-size: 18px;
    }

    .img-alter-plan {
        display: none;
    }

    .div-user {
        padding-left: 20px;
    }
    .button {
        width: 70% !important;
        left: 50%;
        transform: translate(-50%);
        justify-content: center;
    }

}
</style>
  